// The SignalR client's own `withAutomaticReconnect` retries reuse the access
// token captured from the negotiate response, so they can only ride out a short
// blip — once that token expires, nothing but a fresh negotiate recovers the
// connection. The timings below therefore describe two nested ramps: a short,
// bounded one inside the hub client, and an unbounded outer one in the
// middleware that negotiates from scratch each time it fires.

/** Retries the hub client makes on its own before handing over to the middleware. */
export const SIGNALR_HUB_RECONNECT_ATTEMPTS = 4
export const SIGNALR_HUB_RECONNECT_BASE_DELAY_MS = 1000
export const SIGNALR_HUB_RECONNECT_MAX_DELAY_MS = 10000

// The outer ramp is deliberately uncapped in attempts: a Plan Library tab is
// left open all day, and a client that stops trying silently stops receiving
// approval and export notifications for the rest of the session.
export const SIGNALR_RESTART_BASE_DELAY_MS = 2000
export const SIGNALR_RESTART_MAX_DELAY_MS = 60000

export const SIGNALR_NEGOTIATE_MAX_RETRY_ATTEMPTS = 3
export const SIGNALR_NEGOTIATE_BASE_DELAY_MS = 500
export const SIGNALR_NEGOTIATE_MAX_DELAY_MS = 5000

/** Randomises every wait by ±25% so reconnecting clients don't arrive in lockstep. */
export const SIGNALR_BACKOFF_JITTER_RATIO = 0.25
